import { render } from "./IntegrationHub.vue?vue&type=template&id=e5e115b0"
import script from "./IntegrationHub.vue?vue&type=script&lang=js"
export * from "./IntegrationHub.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/project/IntegrationHub.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5e115b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5e115b0', __exports__)) {
    api.reload('e5e115b0', __exports__)
  }
  
  module.hot.accept("./IntegrationHub.vue?vue&type=template&id=e5e115b0", () => {
    api.rerender('e5e115b0', render)
  })

}


export default __exports__